import classNames from 'classnames'
import { useState } from 'react'
import Button from '../../../components/Button'
import Card from '../../../components/Card'
import { ReactComponent as Level10Icon } from './icon-level-10.svg'
import { ReactComponent as Level30Icon } from './icon-level-30.svg'
import { ReactComponent as Level75Icon } from './icon-level-75.svg'
import { ReactComponent as Level100Icon } from './icon-level-100.svg'
import { ReactComponent as BulletIcon } from '../bullet.svg'


export default function AmazonLevelStep({ onSubmit }) {
  let [option, setOption] = useState()
  let options = [
    { icon: Level10Icon, value: '10', label: 'Ganz am Anfang 0-10k' },
    { icon: Level30Icon, value: '30', label: 'Ich bin am Start  10-30k' },
    { icon: Level75Icon, value: '75', label: 'Ich bin im Wachstum 30k-75k' },
    { icon: Level100Icon, value: '100', label: 'Ich bin Experte  100k+' },
  ]

  let disabled = !option

  return (
    <div className='flex flex-col w-full h-full items-center justify-center'>
      <Card withGradient>

        <div className='px-24 py-12 flex text-white gap-36 items-center'>
          <div className='flex flex-col gap-4 w-72 items-start'>
            <div className='text-2xl font-bold'>
              Wo befindest du dich aktuell mit Amazon?
            </div>
            <div className='text-neutral-500 text-lg'>
              Bist du gerade gestartet? Fährst du schon Monster Umsätze oder bist du auf Wachstumskurs?
            </div>
            <Button
                variant='secondary'
                className='text-primary'
                disabled={disabled}
                onClick={() => !disabled && onSubmit({ amazonCurrentLevel: option })}
            >
              <strong className={classNames('px-12 font-bold', !disabled && 'text-primary')}>Weiter</strong>
            </Button>
          </div>

          <div className='flex flex-col gap-4'>
            {options.map((opt) => (
              <div
                key={opt.value}
                className={classNames(
                  'cursor-pointer p-3 rounded-2xl flex gap-2 items-center border-2 min-w-72',
                  option === opt.value ? 'border-primary text-primary bg-secondary' : ' border-neutral-800 text-neutral-300'
                )}
                onClick={() => setOption(opt.value)}
              >
                <opt.icon style={{ width: '28px', height: '28px' }} className={classNames(option !== opt.value && 'text-neutral-600')} />
                <span className='flex-1'>{opt.label}</span>
                <BulletIcon
                  className={classNames('ml-8 mr-2', option === opt.value ? 'text-primary' : 'text-neutral-800')}
                />
              </div>
            ))}
          </div>
        </div>
      </Card>
    </div>
  )
}